module.exports = __webpack_public_path__ + "img/twitter.4192e36f.svg";